import { ref } from 'vue'

import { checkBrowserType } from '@/shared/composables/browser-api'

export enum MediaDevicesErrorType {
    SystemPermissionDenied = 'SystemPermissionDenied',
    UserPermissionDenied = 'UserPermissionDenied',
    CouldNotStartVideoSource = 'CouldNotStartVideoSource',
    Generic = 'Generic',
  }

const errorType = ref(MediaDevicesErrorType.Generic)

export const getDomExceptionErrorType = (error: DOMException)  => {
  const { userBrowser } = checkBrowserType()
  const errName = error.name
  const errMessage = error.message

  if (errName && userBrowser.value) {
    switch (userBrowser.value) {
    case 'chrome': {
      if (errName === 'NotAllowedError') {
        errorType.value = (errMessage === 'Permission denied by system')
          ? MediaDevicesErrorType.SystemPermissionDenied
          : MediaDevicesErrorType.UserPermissionDenied
      } else if (errName === 'NotReadableError') {
        errorType.value = MediaDevicesErrorType.CouldNotStartVideoSource
      }
      return errorType.value
    }
    case 'safari':
    case 'edge': {
      if (errName === 'NotAllowedError') {
        errorType.value = MediaDevicesErrorType.UserPermissionDenied
      } else if (errName === 'NotReadableError') {
        errorType.value = MediaDevicesErrorType.CouldNotStartVideoSource
      }
      return errorType.value
    }
    case 'firefox': {
      if (errName === 'NotFoundError' || errName === 'NotReadableError') {
        errorType.value = MediaDevicesErrorType.SystemPermissionDenied
      } else if (errName === 'NotAllowedError') {
        errorType.value = MediaDevicesErrorType.UserPermissionDenied
      } else if (errName === 'AbortError') {
        errorType.value = MediaDevicesErrorType.CouldNotStartVideoSource
        return
      }
      return errorType.value
    }
    default: {
      console.warn('Unhandled browser:', userBrowser.value)
    }
    }
  }
  return
}
